<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div v-if="contractChangeOperation != null">
                <div class="small-panel">
                    <div class="dialog-title" v-t="'message.title_confirming_cancel_change_contract'">
                    </div>
                    <div class="dialog-body">{{ getContractChangeInformation() }}</div>
                    <div class="dialog-button-field" style="text-align: center">
                        <el-button class="dialog-cancel-button" style="width:160px" @click="$emit('cancel')" v-t="'message.button_no'"></el-button>
                        <el-button class="dialog-ok-button" style="width:160px" @click="$emit('agree')" v-t="'message.button_yes'"></el-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="large-panel" style="height: auto;margin-top: -45vh;min=height: 90vh">
                    <div class="dialog-title">{{ getChangeContractTitle() }}
                    </div>
                    <hr class="dialog-hr">
                    <div id="dialog-body" class="dialog-body">
                        <div class="dialog-description">
                            <span>{{ getContractChangeNotice() }}</span><br>
                            <span v-if="basicContract.purchasePeriodType == 1 && !disablePurchasingOption && basicContract.planType == 0" style="color: #d55169;" v-t="'message.desc_change_contract_notice1'"></span>
                            <span v-else-if="!disablePurchasingOption && basicContract.planType == 0" style="color: #d55169;" v-t="'message.desc_change_contract_notice2'"></span>
                        </div>
                        <div v-if="basicContract.planType == 0">
                            <confirmlicense :appData="appData"
                                            :licenseInfo="confirmLicenseInfo"
                                            :purchasePeriodType="basicContract.purchasePeriodType"
                                            :disablePurchasingOption="disablePurchasingOption"
                                            :confirmType=2
                                            :currencyYen="currencyYen">
                            </confirmlicense>
                        </div>
                        <div v-else>
                            <ConfirmLicenseForPlanPurchasing :appData="appData"
                                            :licenseInfo="appData.numberContract[0]"
                                            :confirmType=2
                                            :planType="appData.basicContract.planType"
                                            :priceOfPlan="priceOfPlan"
                                            :priceNewPlan="priceOfPlan"
                                            :currencyYen="currencyYen">
                            </ConfirmLicenseForPlanPurchasing>
                        </div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="license-item-value" style="text-align: center">
                        <table width="100%">
                            <tr>
                                <td width="50%">
                                    <span v-if="basicContract.purchasePeriodType == 0" v-t="'message.item_amount_monthly'"></span>
                                    <span v-else v-t="'message.item_amount_yearly'"></span>
                                    <span class="total-amount">{{ getCurrentAmountTotal().toLocaleString() }}</span>
                                    <span v-t="'message.unit_currency2'"/>
                                </td>
                                <td width="50%">
                                    <span v-if="basicContract.purchasePeriodType == 0" v-t="'message.item_amount_yearly'"></span>
                                    <span v-else v-t="'message.item_amount_monthly'"></span>
                                    <span class="total-amount">{{ getNewAmountTotal().toLocaleString() }}</span>
                                    <span  v-t="'message.unit_currency2'"/>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="$emit('agree')" v-t="'message.button_save'"></el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import constants from './constants.js';
import ConfirmLicense from './ConfirmLicense.vue';
import ConfirmLicenseForPlanPurchasing from './ConfirmLicenseForPlanPurchasing.vue';

export default {
    data() {
        return {
            confirmLicenseInfo: null,
            priceOfPlan: null,
        };
    },
    methods: {
        getUnitName(licenseType) {
            return commonUtil.getUnitName(this.$i18n, licenseType);
        },
        getCurrentAmountTotal() {
            let totalAmount = 0;
            if (this.basicContract.planType == 0) {
                for (let license of this.licenseInfo.numberLicense) {
                    totalAmount += license.currentAmount;
                }

                for (let license of this.licenseInfo.usageLicense) {
                    totalAmount += license.currentAmount;
                }
    /*
                for (let license of this.licenseInfo.chargedLicense) {
                    totalAmount += license.newAmount;
                    totalAmount += license.currentAmount;
                }
    */
            } else {
                if (this.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    totalAmount = this.appData.numberContract[0].pastMax * this.priceOfPlan.monthPrice;
                } else {
                    totalAmount = this.appData.numberContract[0].pastMax * this.priceOfPlan.yearPrice * 12;
                }
                totalAmount += (totalAmount * this.appData.taxRate);
            }
            return Number(totalAmount);
        },
        getNewAmountTotal() {
            let totalAmount = 0;
            if (this.basicContract.planType == 0) {
                for (let license of this.licenseInfo.numberLicense) {
                    totalAmount += license.newAmount;
                }

                for (let license of this.licenseInfo.usageLicense) {
                    totalAmount += license.newAmount;
                }
            } else {
                if (this.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    totalAmount = this.appData.numberContract[0].currentMax * this.priceOfPlan.yearPrice * 12;
                } else {
                    totalAmount = this.appData.numberContract[0].currentMax * this.priceOfPlan.monthPrice;
                }
                totalAmount += (totalAmount * this.appData.taxRate);
            }

            return Number(totalAmount);
        },
        getUnitPrice(licenseType) {
            for (let price of this.priceList) {
                if (price.type == licenseType) {
                    return price;
                }
            }
        },
        getCurrentContractName() {
            if (this.basicContract.purchasePeriodType ==  constants.PURCHASE_PERIOD_MONTHLY) {
                return commonUtil.getMessageText(this.$i18n,"item_contractType_monthly");
            } else {
                return commonUtil.getMessageText(this.$i18n,"item_contractType_yearly");
            }
        },
        getNewContractName() {
            if (this.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                return commonUtil.getMessageText(this.$i18n,"item_contractType_yearly");
            } else {
                return commonUtil.getMessageText(this.$i18n,"item_contractType_monthly");
            }
        },
        getChangeContractTitle() {
            return commonUtil.getMessageText(this.$i18n,"title_change_contract_type").replace("{from}",this.getCurrentContractName()).replace("{to}",this.getNewContractName())
        },
        getContractChangeNotice() {
            return commonUtil.getContractChangeNotice(this.$i18n, this.basicContract);
        },
        getContractChangeInformation() {
            let nextFlushDateTime = new Date(this.basicContract.nextFlushDatetime).toLocaleString();
            return commonUtil.getMessageText(this.$i18n,"info_cancel_change_contract").replace("{currentContract}",this.getCurrentContractName()).replace("{newContact}",this.getNewContractName()).replace("{nextFlushDate}",nextFlushDateTime);
        }
    },
    components: {
        confirmlicense: ConfirmLicense,
        ConfirmLicenseForPlanPurchasing
    },
    created: function() {
        this.confirmLicenseInfo = this.licenseInfo;
        if (this.basicContract.planType == 0) {
            for (let license of this.confirmLicenseInfo.numberLicense) {
                license.price = this.getUnitPrice(license.type)
                license.displayName = commonUtil.getLicenseName(this.$i18n, license.type);
                if (this.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    license.currentAmount = license.pastMax * license.price.monthPrice * (1 + this.appData.taxRate);
                    license.newAmount = license.orgValue * license.price.yearPrice * 12 * (1 + this.appData.taxRate);
                } else {
                    license.currentAmount = license.pastMax * license.price.yearPrice * 12 * (1 + this.appData.taxRate);
                    license.newAmount = license.orgValue * license.price.monthPrice * (1 + this.appData.taxRate);
                }
            }
            for (let license of this.confirmLicenseInfo.usageLicense) {
                license.price = this.getUnitPrice(license.type)
                license.displayName = commonUtil.getLicenseName(this.$i18n, license.type);
                switch(license.type) {
                    case constants.RECURRING_SPEECH_TEXT:
                        license.unit = constants.PURCHASE_UNIT_SPEECH_TEXT;
                        license.currentAmount = (license.orgValue/license.unit) * license.price.usagePrice * (1 + this.appData.taxRate);
                        license.newAmount = license.currentAmount;
                        break;
                    case constants.RECURRING_TRANSLATION:
                        license.unit = constants.PURCHASE_UNIT_TRANSLATE;
                        license.currentAmount = (license.orgValue/license.unit) * license.price.usagePrice * (1 + this.appData.taxRate);
                        license.newAmount = license.currentAmount;
                        break;
                }
            }
            /*
            for (let license of this.confirmLicenseInfo.chargedLicense) {
                switch(license.type) {
                    case constants.CHARGE_SPEECH_TEXT:
                        license.unit = constants.PURCHASE_UNIT_SPEECH_TEXT;
                        break;
                    case constants.CHARGE_TRANSLATION:
                        license.unit = constants.PURCHASE_UNIT_TRANSLATE;
                        break;
                }
                license.displayName = commonUtil.getLicenseName(this.$i18n, license.type);
                license.price = this.getUnitPrice(license.type)
                license.currentAmount = license.quantity * license.price.usagePrice;
                license.newAmount = 0;
            }
            */
        } else {
            this.priceOfPlan = this.getUnitPrice(this.basicContract.planType)
        }
    },
    props: [ 'appData' , 'basicContract' , 'licenseInfo' ,  'priceList' , 'contractChangeOperation' , 'disablePurchasingOption' , 'currencyYen']
}
</script scoped>
<style scoped>

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    max-height: calc(80vh - 290px);
    overflow: auto;
}

.license-item-value >>> .el-input-number {
    width: 160px;
}

.item >>> .el-popper[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff;
}

</style scoped>
